<template>

  <!-- ==================================== -->
  <!-- ====== разбить на компоненты ======= -->
  <!-- ==================================== -->

  <div class="event-wrap" v-if="allFeeds.length" v-loading="loading">
      <el-button type="primary" @click="eventAddCardShow = !eventAddCardShow" size="small">Добавить событие</el-button>

      <div class="event-add-wrap">
        <div :class="eventAddClass">
          <el-card shadow="always" >
            <div slot="header" class="clearfix">
              <span>Добавление события</span>
            </div>

            <el-form :model="form" style="margin-bottom: 25px">
              <el-form-item label="Название" style="margin-right: 15px;">
                <el-input v-model="form.name" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="Координаты">
                <el-input v-model="form.coord_line" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button @click="dialogEventVisible = true; onEvent=false" size="small">Добавить на карте</el-button>
              </el-form-item>
            </el-form>

            <el-divider></el-divider>

            <span class="dialog-footer">
             <el-button type="primary" @click="saveEvent()">Добавить</el-button>
              <el-button @click="eventAddCardShow = false" size="small">Отмена</el-button>
            </span>
          </el-card>
        </div>
      </div>


      <h3 class="events-list-title">Список событий:</h3>
      <el-divider></el-divider>

      <el-card shadow="hover" style="margin-bottom: 25px" v-for="(balloon, idx) in balloons" :key="idx">
        <el-form :model="balloon" style="margin-bottom: 25px">
          <el-form-item label="Название" style="margin-right: 15px;">
            <el-input v-model="balloon.title" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Координаты">
            <el-input v-model="balloon.coord_line" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              @click="dialogEventVisible = true; onEvent=true; activeEvent=balloon"
              size="small"
            >Изменить на карте</el-button>
          </el-form-item>
        </el-form>

        <el-collapse style="margin-bottom: 25px">
          <el-collapse-item title="Ключевые слова" name="keywords">
            <el-form>
              <el-form-item>
                <div class="key-wrap">
                  <div class="key-wrap__item" v-for="(key, idx) in balloon.keywords" :key="idx">
                    <span class="key-wrap__button" @click="deleteKey(balloon.id, key.id)">X</span>
                    <el-input
                      v-model="key.keyword"
                      autocomplete="off"
                      disabled
                    >
                    </el-input>
                  </div>

                  <div class="key-wrap__item">
                    <el-input
                      v-model="form.keyword.value"
                      autocomplete="off"
                      placeholder="Введите ключ"
                    >
                    </el-input>
                  </div>
                </div>
                <el-button @click="addKey(balloon)">Добавить</el-button>
              </el-form-item>
            </el-form>
          </el-collapse-item>
        </el-collapse>

          <span class="dialog-footer">
           <el-button type="primary" @click="saveEvent(balloon)">Изменить</el-button>
            <el-button type="danger" @click="removeEvent(balloon)">Удалить</el-button>
          </span>
      </el-card>

      <el-dialog width="70%" title="Добавление события на карте" :visible.sync="dialogEventVisible">
        <ymap @setEvent="setEvent" :coords="userCityMapCoords" :onEvent="onEvent" @onEventAdd="onEventAdd"/>
      </el-dialog>
  </div>
</template>

<script>
  // vuex
  import { mapGetters } from 'vuex';

  // api
  import  {
    saveEventApi,
    addKeywordEventApi,
    removeKeywordEventApi,
    removeEventsApi,
    listEventKeywordsApi,
    getThreadEventsApi
  } from '../../../../../api/events';

  // components
  import Ymap from "@/components/yMap/Ymap";

  export default {
    name:  "Events",
    props: {
      active: {
        type: Boolean
      },
    },
    data() {
      return {
        loading: false,
        dialogEventVisible: false,
        form: {
          name: '',
          coord_line: '',
          keyword: {value: ''},
        },
        activeEvent: {},
        onEvent: false,
        balloons: [],
        eventCoords: '',
        eventLoading: false,
        eventAddCardShow: false
      };
    },
    computed: {
      ...mapGetters([
        'allFeeds',
        'userId',
        'userCityMapCoords'
      ]),
      eventAddClass() {
        return this.eventAddCardShow ? 'event-add-wrap__item event-add-wrap__item--show' : 'event-add-wrap__item';
      },
    },
    methods: {
      onEventAdd(coords) {
        this.balloons = this.balloons.map(item => {
          if (item.id === this.activeEvent.id) {
            item.coord_line = coords;
          }

          return item;
        });
        console.log(coords);
      },
      removeEvent(balloon) {
        let params = {
          event_id: balloon.id,
        };

        removeEventsApi(params).then(()=>{
          this.balloons = this.balloons.filter(item => item.id !== balloon.id);
        });
      },
      setEvent(coords) {
        this.dialogEventVisible = false;
        this.form.coord_line = coords;
      },
      saveEvent(balloon) {
        let params = {
          id: balloon ? balloon.id : 0,
          thread_id: this.$route.params.threadId,
          title: balloon ? balloon.title : this.form.name,
          coord_center: this.userCityMapCoords.join(','),
          coord_line: balloon ? balloon.coord_line : this.form.coord_line.replace(/\s/g, '')
        };

        this.eventLoading = true;

        saveEventApi(params).then((resp)=>{
          this.eventLoading = false;
          if (!balloon) {
            this.balloons.push({...resp.data, keywords: []});
          }
          this.form.name = '';
          this.form.coord_line = '';
          this.eventAddCardShow = false;
        });
      },
      addKey(balloon) {
        if (this.form.keyword.value) {
          let params = {
            event_id: balloon.id,
            keyword: this.form.keyword.value
          };

          this.eventLoading = true;

          addKeywordEventApi(params).then(() => {
            const currentBalloonIndex = this.balloons.findIndex(item => item.id === balloon.id)
            this.balloons[currentBalloonIndex].keywords.push({keyword: this.form.keyword.value})

            this.eventLoading = false;
            this.form.keyword.value = '';
          });
        }
      },
      deleteKey(balloonId, keywordId){
        removeKeywordEventApi({ id: keywordId }).then(() => {
          const balloonIndex = this.balloons.findIndex(item => item.id === balloonId)
          const keywords = this.balloons[balloonIndex].keywords
          const keywordIndex = keywords.findIndex(item => item.id === keywordId)
          const before = keywords.slice(0, keywordIndex)
          const after = keywords.slice(keywordIndex + 1)
          this.balloons[balloonIndex].keywords = [ ...before, ...after]
        })
      },
      getEvents() {
        this.loading = true;
        let params = {
          thread_id: this.$route.params.threadId,
        };

        getThreadEventsApi(params).then(resp => {
          let data = resp.data.filter(item => item.coord_line !== '');
          Promise.all(data.map(async item =>
            listEventKeywordsApi({event_id: item.id})
              .then(resp => {
                return  {...item, keywords: resp.data};
              })
          )).then(data => {
            this.balloons = data.filter(item => item.coord_line !== '');
            this.loading = false;
          });
        });
      },
    },
    components: {
      Ymap
    },
    watch: {
      active(arg) {
        if (arg) {
          this.getEvents();
        }
      },
    },
  };
</script>

<style>
  .event-wrap {
    min-height: 500px;
  }
  .event-add-wrap {
    position: relative;
    height: 0px;
    z-index: 300;
    margin-top: 10px;
  }
  .event-add-wrap__item {
    width: 100%;
    position: absolute;
    bottom: 100px;
    transition: all 400ms linear 0s;
    background-color: #fff;
  }
  .event-add-wrap__item--show {
    bottom: -380px;
  }
  .key-wrap {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;
  }
  .key-wrap__item {
    width: 150px;
    margin-right: 15px;
    margin-bottom: 15px;
    position: relative;
  }
  .key-wrap__item:last-child {
    margin-right: 0;
  }
  .key-wrap__button {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -5px;
    right: -5px;
    z-index: 100;
    width: 20px;
    height: 20px;
    border: 1px solid #c0ccda;
    border-radius: 50%;
    background-color: #fff;
    cursor: pointer;
  }
  .dialog-footer {
    margin-top: 15px;
  }
  .events-list-title{
    color: #1F2F3D;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
  }
</style>
